<template>
  <div>
    <div class="header-all" v-if="!$route.query.t ||!($route.query.t==headType.wxShare)">
      <div class="banner-contain">
        <v-total :type="type"></v-total>

      </div>
      <v-classHead :type="type"></v-classHead>
    </div>
    <div class="share-main" :style="hight">
      <div  :class="css">
        <img :src="taoke.Pic"/>
      </div>
      <div v-if="!$route.query.t || !($route.query.t==headType.wxShare)">
        <div class="share-desc">
          {{taoke.D_title}}
        </div>
        <div class="share-main-body">
          <div class="share-main-body-left">
            <div class="left">
                  ¥<span class="share-price">
                {{taoke.Price}}
              </span>
              <span class="share-price-desc">
                {{quanDesc}}
              </span>
            </div>
            <div class="right">
              <img :src="showImg()"/>
            </div>
          </div>
          <div class="share-main-body-right">
            <span class="share-quan" v-show="isShowQuan">{{taoke.Quan_price|subPrice}}元券</span>
            <span class="share-num">{{taoke.Sales_num}}笔成交</span>
          </div>
        </div>
        <div class="share-main-foot">
          <button @click="public.gotoDetail(taoke,$route.query.t)">立即购买</button>
        </div>
      </div>
      <div v-else>
        <div class="wx-main-body">
            <div class="wx-main-body-left">
              <div class="wx-main-body-left-title">
                {{taoke.D_title}}
              </div>
              <div class="wx-main-body-left-quan">
                <div class="wx-left">
                  ¥<span class="wx-price">
                  {{taoke.Price}}
                </span>
                <span class="wx-price-desc">
                  {{quanDesc}}
               </span>
                </div>
                <div class="wx-right">
                  <span class="wx-quan" v-show="isShowQuan">{{taoke.Quan_price|subPrice}}元券</span>
                </div>
                <div style="clear:both"></div>
              </div>
              <div class="wx-main-body-left-n">
                <img :src="showImg()"/>
                <span class="wx-num">{{taoke.Sales_num}}笔成交</span>
              </div>
            </div>
            <div class="wx-main-body-right">
              <canvas id="qr"></canvas>
              <div class="wx-main-body-right-text">长按"识别图中二维码"</div>
            </div>
            <div style="clear: both"></div>
        </div>
        <div class="wx-main-foot">
          <span>扫码领券，才省钱！</span>
        </div>
      </div>
    </div>
    <div class="share-foot" v-if="!$route.query.t || !($route.query.t==headType.wxShare)">
      <div>
        <img :src="require('../../static/img/tuijian.jpg')"/>
      </div>
      <div class="flower-deco"></div>
      <div class="more-products">
        <span>Top100小编推荐，超值包邮</span>
      </div>
      <v-body :type="type" params='' :item="taoke" v-if="isShowBody"></v-body>
    </div>
  </div>
</template>
<script>
  import TotalHeader from './taoke/TotalHeader.vue';
  import ClassHead from './taoke/ClassHeader.vue';
  import Body from './Body.vue';
  import QRious from 'qrious';
  export default{
    name:'Share',
    data(){
      return{
        taoke:{},
        isShowQuan:true,
        quanDesc:'',
        isShowBody:false,
        showShare:true,
        css:'share-main-head-share',
        type:this.headType.share,
        host:location.href.slice(0,location.href.indexOf("#")),
        hight:{},
        downloadUrl:''
      }
    },
    components:{
      'v-total':TotalHeader,
      'v-classHead':ClassHead,
      'v-body':Body
    },
    created(){
      var createIframe=(function(){
        var iframe;
        return function(){
          if(iframe){
            return iframe;
          }else{
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            return iframe;
          }
        }
      })();
      let seft = this;
      var baseScheme = "yiqimmm://test";
      var openApp=function(){
        var localUrl=baseScheme;
        var openIframe=createIframe();
        if(seft.isIos){
          //判断是否是ios,具体的判断函数自行百度
          //window.location.href = localUrl;
        }else if(seft.isAndroid){
          openIframe.src = localUrl;
        }
      };
      openApp();
      if(this.$route.query.t){
        this.type = this.$route.query.t;
      }
      if(this.$route.query.t==this.headType.wxShare){
        this.hight = {};
        this.css = "share-main-head";
      }else{
        this.hight = {'margin-top':'7.5rem'};
      }
      this.http.get(this.https.getTaoke+this.$route.query.id).then(function(response){
        if(response.data && response.data.GoodsID){
          seft.taoke = response.data;
          seft.downloadUrl = seft.host+"#Detail?id="+seft.taoke.uuid+"&goodsId="+seft.taoke.GoodsID+"&t=8";
          var qr = new QRious({
            element: document.getElementById('qr'),
            value: seft.downloadUrl
          });
          if(seft.taoke.Quan_time){
            seft.isShowQuan = true;
            seft.quanDesc = "券后价";
          }else{
            seft.isShowQuan = false;
            seft.quanDesc = "优惠价";
          }
        }else{
          seft.http.get(seft.https.getProduct+"?url="+window.encodeURIComponent(seft.taoConfig+seft.$route.query.goodsId)).then(function(res){
            seft.taoke = res.data;
            seft.downloadUrl = seft.host+"#Detail?id="+seft.taoke.uuid+"&goodsId="+seft.taoke.GoodsID+"&t=8";
            if(seft.taoke.Quan_time){
              seft.isShowQuan = true;
              seft.quanDesc = "券后价";
            }else{
              seft.isShowQuan = false;
              seft.quanDesc = "优惠价";
            }
            var qr = new QRious({
              element: document.getElementById('qr'),
              value: seft.downloadUrl
            });
          }).catch(function(error){
            console.error(error);
          })
        }
        seft.isShowBody =true;
      }).catch(function(error){
        console.error(error);
      })
    },
    filters:{
      subPrice:function(value){
        if(typeof value!='undefined'){
          var idx = value.indexOf(".");
          if(idx>-1){
            value = value.slice(0,idx);
          }
        }
        return value;
      }
    },
    mounted(){
      if(this.isPc){
        document.getElementsByClassName("header-all")[0].style.maxWidth='750px';
        document.getElementById("app").style.maxWidth='750px';
      }
      this.http.get(this.https.getPkgName+(this.$route.query.pkgName?this.$route.query.pkgName:'mmma')).then(function(res){
        document.title = res.data.name;
      }).catch(function(error){
        document.title = "一起买买买";
        console.error(error);
      });
      this.watcher.$on('closeHeader',function(type){
        if(type==seft.headType.share || type==seft.headType.wxDetail){
          seft.hight = {'margin-top':'3rem'};
        }
      });
    },
    watch:{

    },
    methods:{
      showImg(){
        if(this.taoke.sourceType==7&&!this.taoke.freePost){
          if(this.taoke.IsTmall=="1"){
            return require("../../static/img/tmall1.png");
          }else{
            return require("../../static/img/tao1.png");
          }
        }else{
          if(this.taoke.IsTmall=="1"){
            return require("../../static/img/cat_bao.png");
          }else{
            return require("../../static/img/tao_baoyou.png");
          }
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// Share.vue?752e9d0a